import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ChangePassword() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      const me = await api.get("/auth/me");
      setUser(me.data);
      toast.success("Password changed successfully");
      navigate("/dashboard");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md">
      <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mb-6" data-testid="back-btn">
        <ArrowLeft className="h-4 w-4" /> Back
      </button>
      <h1 className="text-2xl font-heading font-bold text-slate-900">Change Password</h1>
      <form onSubmit={submit} className="mt-6 space-y-4 bg-white p-6 rounded-xl border border-slate-200">
        <div>
          <Label>Current Password</Label>
          <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required className="mt-1.5" data-testid="current-password" />
        </div>
        <div>
          <Label>New Password</Label>
          <Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} required minLength={6} className="mt-1.5" data-testid="new-password" />
        </div>
        <Button type="submit" disabled={loading} data-testid="save-password-btn">Update Password</Button>
      </form>
    </div>
  );
}
